export default {
    "profile": "Wasifu",
    "logout": "Ondoka",
    "dashboard": "Dashibodi",
    "password": "Nenosiri",
    "language": "Lugha",
    "paymentbr": "Malipo",
    "subscriptionPaymentMethod": "Usajili na Mbinu ya Malipo",
    "nothingchanged": "Hakuna Iliyobadilika",
    "somethingWentWrong": "Hitilafu fulani imetokea! Tafadhali jaribu tena baadaye",
    "pleaseTryAgainAfterSometime": "Tafadhali jaribu tena baada ya muda fulani",
    "noChanges": "Haijabadilishwa",
    "invalidEmailFormat": "Umbizo la barua pepe si sahihi",
    "chooseYourPreferredLanguage": "Tafadhali chagua lugha unayopendelea.",
    "selectLanguage": "Chagua Lugha",
    "update": "Sasisha",
    "languagePreferences": "Mapendeleo ya Lugha",
    "packageOf": "Kifurushi cha",
    "satelliteReport": "ripoti za satelaiti",
    "pastureReport": "taarifa za malisho",
    "upTo": "Hadi",
    "animals": "wanyama",
    "back": "Nyuma",
    "perMonth": "Kwa mwezi",
    "perYear": "Kwa Mwaka",
    "continue": "Endelea",
    "changePlan": "Badilisha Mpango",
    "addOn": "Nyongeza",
    "totalPrice": "Bei jumla",
    "availableAddOns": "Viongezi Vinavyopatikana",
    "next": "Inayofuata",
    "congratulations": "Hongera sana",
    "done": "IMEKWISHA",
    "deforestationComplianceAssessment": "Tathmini za Uzingatiaji wa Ukataji miti",
    "warning": "Onyo",
    "yourDataMightLost": "Data yako inaweza kupotea.",
    "clickOnSaveBtnMsg": "Bofya kitufe cha kuhifadhi ili kuhifadhi data yako",
    "discardChanges": "Tupa Mabadiliko",
    "action": "Vitendo",
    "sendRequest": "Tuma ombi",
    "success": "Mafanikio",
    "yourRequestSuccessfullySubmitted": "Ombi lako limewasilishwa.",
    "informShortly": "Ombi lako limewasilishwa kwa mafanikio. Ripoti yako ya uchanganuzi itatumwa kwako hivi karibuni.",
    "search": "Tafuta",
    "pending": "Inasubiri",
    "approved": "Imeidhinishwa",
    "rejected": "Imekataliwa",
    "primaryGeofence": "Geofence ya Msingi",
    "Zero/Negligible Deforestation Probability": "Uwezekano wa Ukataji Miti Sifuri/Ndogo",
    "Low Deforestation Probability": "Uwezekano wa Chini wa Ukataji Miti",
    "High Deforestation Probability": "Uwezekano Mkubwa wa Ukataji Miti",
    "login": {
        "welcome": "Karibu! Ingia",
        "welInfo": "Weka kitambulisho chako.",
        "login": "Ingia",
        "emailMobile": "Barua pepe/Simu",
        "forgotPassword": "Umesahau nywila",
        "register": "Sajili",
        "unableToLogin": "Haiwezi Kuingia",
        "emailMobileCannotEmpty": "Barua pepe/Rununu haiwezi kuwa tupu.",
        "invalidEmailMobileFormat": "Umbizo batili la barua pepe/simu.",
        "passwordCannotEmpty": "Nenosiri haliwezi kuwa tupu.",
        "passwordLengthCanlessthan8": "Urefu wa nenosiri hauwezi kuwa chini ya herufi 8.",
        "email": "Barua pepe",
        "phone": "Simu",
        "or": "AU",
        "alreadyHaveAccount": "Tayari unayo akaunti",
        "loginNow": "Ingia Sasa",
        "registerOption": "Chagua chaguo kujiandikisha",
        "signUpWith": "Jisajili na"
    },
    "user": {
        "profileUpdated": "Wasifu umesasishwa",
        "profileNotUpdated": "Wasifu haujasasishwa",
        "otpSentOnEmail": "OTP ilitumwa kwa mafanikio!",
        "otpSentSuccessFully": "Msimbo wako wa OTP ulitumwa",
        "unableToVerifyEmail": "Imeshindwa kuthibitisha barua pepe",
        "emailCanNotBeEmpty": "Sehemu za barua pepe haziwezi tupu",
        "firstName": "Jina la kwanza",
        "lastName": "Jina la familia",
        "email": "Barua pepe",
        "mobile": "Rununu",
        "currentPassword": "Nenosiri la sasa",
        "newPassword": "Nenosiri Mpya",
        "repeatNewPassword": "Rudia Nenosiri Jipya",
        "firstNameRequired": "Jina la kwanza linahitajika.",
        "lastNameRequired": "Jina la mwisho linahitajika",
        "emailRequired": "Barua pepe inahitajika",
        "onlyAlphabet": "Inaweza kuwa na alfabeti pekee",
        "notMoreThan15Char": "Haiwezi kuwa zaidi ya herufi 15",
        "phoneCannotLessThan8Char": "Simu haiwezi kuwa chini ya char 8",
        "countryCodeRequire": "Msimbo wa nchi unahitajika",
        "changePassword": "Badilisha neno la siri",
        "goodIdeaToUsePassword": "Ni wazo nzuri kutumia nenosiri dhabiti ambalo hutumii mahali pengine.",
        "enterCurrentPassword": "Weka Nenosiri la Sasa",
        "enterNewPassword": "Weka Nenosiri Jipya",
        "reEnterPassword": "Weka tena Nenosiri",
        "pleaseTypeOldPassword": "Tafadhali andika nenosiri la zamani.",
        "pleaseTypeNewPassword": "Tafadhali andika nenosiri jipya.",
        "pleaseTypeConfirmPassword": "Tafadhali chapa thibitisha nenosiri.",
        "passwordChangedSuccesFully": "Nenosiri limebadilishwa",
        "passwordDoesNotMatch": "Manenosiri hayalingani.",
        "passwordRequired": "Nenosiri linahitajika",
        "emailOrPhoneIsRequired": "Barua pepe au Nambari ya Simu inahitajika"
    },
    "subscription": {
        "subscription": "Usajili",
        "membershipPlan": "Mipango ya Uanachama",
        "currentMembershipPlan": "Mpango wa sasa wa uanachama",
        "validUpTo": "Halali Hadi",
        "viewAllAddOns": "TAZAMA NYONGEZO ZOTE",
        "renewValidity": "Sasisha Uhalali",
        "buyNow": "Nunua Sasa",
        "upgradeMembershipPlan": "Boresha mpango wa uanachama",
        "chooseYourMembershipPlan": "Mpango Wako Uliochaguliwa wa Uanachama",
        "chooseOptionalAddOns": "Unaweza kuchagua Viongezi vya hiari",
        "yourSelectedAddons": "Viongezi Ulivyochagua",
        "addAnotherAddOn": "Ongeza Nyongeza Nyingine",
        "paymentMethod": "Njia ya malipo",
        "addingAPaymentMethod": "Kuongeza Njia ya Malipo",
        "paymentSuccessful": "Malipo Yako Yamefaulu!",
        "weHaveEmailed": "Tumetuma nakala ya mpokeaji wako kwa barua pepe kwa example@email.com",
        "paymentAuthorizedSuccessfully": "Malipo yameidhinishwa.",
        "paymentSuccessfulPrompt": "Malipo yamefaulu. Mpango umeboreshwa.",
        "paymentCancelled": "Malipo yameghairiwa. Tafadhali jaribu tena."
    },
    "registerFarm": "Shamba la usajili",
    "requestDeforestationReport": "Omba Ripoti ya Ukataji miti",
    "paymentMenu": "Malipo",
    "complianceCertificate": "Cheti cha Kuzingatia",
    "helpDisk": "Diski ya Msaada",
    "faqs": "Maswali Yanayoulizwa Mara kwa Mara",
    "enquiries": "Maswali",
    "contactUs": "Wasiliana nasi",
    "payment": {
        "basicPlan": "Mpango wa Msingi",
        "advancePlan": "Mpango wa Mapema",
        "usdPerMonthPlus": "USD kwa mwezi plus",
        "perReport": "kwa ripoti",
        "deforestationAnalyticsCertificateDownload": "Upakuaji wa cheti cha uchanganuzi wa ukataji miti"
    },
    "farm": {
        "farmOwnershipType": "Aina ya Umiliki wa Shamba",
        "licenceNum": "Nambari ya Leseni",
        "viewFarm": "Tazama Shamba",
        "stateProvince": "Mkoa/Jimbo",
        "postalNumberShouldSimilarToFarm": "Nambari ya posta ya shamba sawa na nambari ya Nyumba.",
        "videoTutorial": "Mafunzo ya Video",
        "clickOnMapMSG": "Bofya kwenye ramani ili kuanza geofencing",
        "prev": "Iliyotangulia",
        "next": "Inayofuata",
        "dragVertexMsg": "Unaweza pia kuburuta vertex, au kuifuta kwa kutumia kitufe cha kufuta upande wa kulia. Geofence pia inaweza kufutwa kwa kutumia kitufe kilicho wazi",
        "farmAddedSuccessfully": "Shamba limeongezwa kwa mafanikio",
        "perimeter": "Mzunguko",
        "area": "Eneo",
        "clearGeofence": "Futa Geofence",
        "deleteSelectedVertex": "Futa Vertex Iliyochaguliwa",
        "pleaseStartDrawing": "Tafadhali anza kuchora uzio wa geofence kwenye ramani.",
        "chooseTheDate": "Chagua tarehe",
        "updateGeofenceForThisFarm": "SASISHA GEOFENCE kwa shamba hili",
        "farmUpdateSuccessfully": "Shamba limesasishwa",
        "farmZone": "Kanda za Shamba",
        "addNewZones": "Ongeza Kanda Mpya",
        "zoneName": "Jina la Kanda",
        "addZoneToCreate": "Tafadhali bofya Ongeza Kanda ili kuunda Eneo la shamba hili.",
        "noZoneCreated": "Bado hakuna Kanda ambazo zimeundwa.",
        "searchAndAddPin": "Tafuta na uongeze pini",
        "zoneNameWillBeHere": "Jina la Eneo litakuwa hapa",
        "editZone": "Hariri Eneo",
        "nameOfTheField": "Jina la Shamba",
        "zoneDetails": "Maelezo ya Eneo",
        "addZone": "Ongeza Eneo",
        "nameOfTheZone": "Jina la Kanda",
        "geofenceIsRequiredToAdd": "Geofence inahitajika ili kuongeza eneo. Bofya `Hariri Shamba` ili kuongeza maelezo ya Geofence kwenye shamba lako.",
        "thisFieldApplyHelpText": "Sehemu hii inatumika kwako tu ikiwa wewe ni mwanachama wa ushirika wowote ( Ushirika ni chama kinachojitegemea cha watu walioungana kwa hiari ili kukidhi mahitaji na matarajio yao ya kiuchumi, kijamii na kiutamaduni kupitia biashara inayomilikiwa kwa pamoja na inayodhibitiwa kidemokrasia). IKIWA wewe ni wa chama cha ushirika, tafadhali onyesha kitambulisho cha kipekee cha ushirika huo, inaweza kuwa nambari ya usajili au leseni inayotambulisha ushirika unaoshiriki nao.",
        "farmRegistrationID": "Kitambulisho cha Usajili wa Shamba",
        "farmerName": "Jina la Mkulima",
        "farmerRegistrationID": "Kitambulisho cha Usajili wa Mkulima",
        "dateOfRequest": "Tarehe ya Ombi",
        "status": "Hali",
        "address": "Anwani",
        "save": "Hifadhi",
        "farmAddress": "Anwani ya Eneo la Shamba",
        "corporateName": "Jina la Shirika",
        "corporateMailingAddress": "Anwani ya Barua Pepe ya Biashara",
        "farmID": "Kitambulisho cha shamba",
        "onTheFarm": "Kwenye Shamba",
        "userRoles": "Majukumu ya Mtumiaji",
        "adduser": "Ongeza Mtumiaji",
        "addAuser": "Ongeza Mtumiaji",
        "uploadUsers": "Pakia Watumiaji",
        "addNewUser": "Ongeza Mtumiaji Mpya",
        "selectDept": "Idara iliyochaguliwa",
        "selectRole": "Chagua Jukumu",
        "editUser": "Badilisha Mtumiaji",
        "totalFarms": "Jumla ya Mashamba",
        "NoAnimalsRegisteredForthisFarm": "Hakuna Wanyama Waliosajiliwa kwa Shamba hili",
        "farmsPerPage": "Mashamba kwa kila ukurasa",
        "regularFarms": "Mashamba ya Kawaida",
        "farmRegisteredProducts": "Bidhaa Zilizosajiliwa na Shamba",
        "searchByFarmNameAndId": "Tafuta kwa Jina la Shamba na Kitambulisho",
        "loadingProductsPleaseWait": "Inapakia Bidhaa... Tafadhali subiri",
        "farmName": "Jina la Shamba",
        "farmLocation": "Eneo la Shamba",
        "productName": "Jina la bidhaa",
        "stockStatus": "Hali ya Hisa",
        "inStock": "Katika Hisa",
        "searchByProductName": "Tafuta Kwa Jina la Bidhaa",
        "productCategory": "Aina ya Bidhaa",
        "products": "Bidhaa",
        "yourLocationIsDisabled": "Eneo lako limezimwa. Tafadhali tafuta eneo lako kutoka kwa menyu za kushoto.",
        "close": "Funga",
        "farms": "Mashamba",
        "zones": "Kanda",
        "registerAfarm": "Sajili Shamba",
        "govtRegistry": "Serikali. Usajili",
        "cooperativeID": "Kitambulisho cha Ushirika/Muungano",
        "cooperativeName": "Jina la Ushirika/Muungano",
        "farmType": "Aina ya Shamba",
        "contractMating": "Kuoana kwa Mkataba",
        "customization": "Kubinafsisha",
        "recordsPerpage": "Rekodi kwa kila Ukurasa",
        "restoreDefault": "Rejesha Chaguomsingi",
        "apply": "Omba",
        "CommunityName": "Jina la Jumuiya",
        "searchState": "Tafuta kwa Kitambulisho cha Shamba, Masjala ya Serikali, Kitambulisho cha Ushirika, Aina ya Shamba, Kuoana kwa Mkataba",
        "farmOwner": "Mmiliki wa Shamba",
        "govRegistrationNo": "Nambari ya Usajili ya Serikali",
        "farmInformation": "Habari za shamba",
        "ownershipType": "Aina ya Umiliki",
        "farmLicenseInformation": "Taarifa ya Leseni ya Shamba",
        "licenseNumber": "Nambari ya Leseni",
        "licenseExpiryDate": "Tarehe ya Kuisha kwa Leseni",
        "regulatorName": "Jina la Mdhibiti",
        "regulatorRepresentativeName": "Jina la Mwakilishi wa Mdhibiti",
        "farmLocationSize": "Eneo la Shamba na Ukubwa",
        "productionSystem": "Mfumo wa Kilimo",
        "country": "Nchi",
        "state": "Jimbo",
        "city": "Kijiji/Mji/Jiji",
        "farmNumber": "Nambari ya shamba",
        "postal": "Msimbo wa Posta/Zip",
        "houseNumber": "Nambari ya Nyumba",
        "farmRegistration": "Usajili wa Shamba",
        "cancel": "Ghairi",
        "register": "Sajili",
        "ok": "sawa",
        "totalFarmSize": "Jumla ya Ukubwa wa Shamba",
        "geographicLocation": "Eneo la Kijiografia",
        "farmGeographicLocation": "Mahali pa Kijiografia cha Shamba",
        "perimeterPointLongitude": "Urefu wa Pointi ya mzunguko",
        "perimeterPointLatitude": "Latitudo ya Uhakika wa mzunguko",
        "perimeterPointLabel": "Lebo ya Uhakika wa Mzunguko",
        "perimeterLength": "Urefu wa Mzunguko",
        "farmLatitude": "Latitudo ya shamba",
        "farmLongitude": "Urefu wa shamba",
        "latitude": "Latitudo",
        "longitude": "Longitude",
        "areaUnit": "Kitengo cha eneo",
        "walkAndMeasure": "TEMBEA NA KUPIMA",
        "useGeofenceTool": "TUMIA CHOMBO CHA GEOFENCE",
        "editFarm": "Badilisha Shamba",
        "update": "Sasisha",
        "editAfarm": "Hariri shamba",
        "nextFarm": "Kilimo Kinachofuata",
        "nameoftheFarm": "Jina la Shamba",
        "registerAProduct": " Sajili Bidhaa",
        "farmProducts": "Bidhaa za Shamba",
        "calf": "Ndama",
        "steer": "Badili",
        "heifer": "Ng'ombe",
        "sire": "Bwana",
        "dam": "Bwawa",
        "registerAnAnimal": "Kusajili Mnyama",
        "farmAnimals": "Mifugo",
        "farm_type": "Aina ya shamba",
        "farm_Owner": "Mmiliki wa Shamba",
        "dateOfRegistration": "Tarehe ya Usajili",
        "dataIsNotAvailableForThisFarm": "Data Haipatikani kwa Shamba hili",
        "registerNewProduct": "Sajili Bidhaa Mpya",
        "information": "Habari",
        "licenseInfo": "Maelezo ya Leseni",
        "locationInfo": "Maelezo ya Mahali",
        "geoLocation": "Mahali pa Geo",
        "perimeterLengthState": "Urefu wa Mzunguko wa Mashamba (urefu wa uzio)",
        "totalFarmSizeState": "Ukubwa wa Shamba",
        "productionSystemState": "Mfumo wa Uzalishaji unaotumika shambani",
        "contractMatingState": "Kanuni ya Mpango wa Kupandisha Mkataba ambao Shamba Inashiriki.",
        "ownershipTypeState": "Aina ya Umiliki",
        "regulatorRepresentativeNameState": "Jina la mtu anayewakilisha mdhibiti aliyetoa leseni",
        "regulatorNameState": "Jina la mdhibiti aliyetoa leseni",
        "licenseExpiryDateState": "Tarehe ambayo Leseni ya sasa imeisha Muda wake",
        "licenseNumberState": "Nambari ya Leseni iliyotolewa na Mdhibiti",
        "plotNumberState": "Nambari ya nyumba ya shamba.",
        "plotNumber": "Nambari ya shamba",
        "streetStatement": "Jina la mtaa wa shamba.",
        "cityStatement": "Jiji ambalo shamba liko.",
        "stateStatement": "Mkoa wa nchi ambapo shamba liko.",
        "countryState": "Nchi ambayo shamba liko.",
        "farmStateInfo": "Anwani ya eneo la shamba",
        "perimeterPointLongitudeState": "Urefu wa pointi moja kwenye shamba.",
        "perimeterPointLatitudeState": "Latitudo ya hatua moja kwenye shamba.",
        "perimeterPointLabelState": "Lebo ya Point.",
        "farmLongitudeState": "Longitude ya shamba.",
        "farmLatitudeState": "Latitudo ya shamba.",
        "deleteFarm": "Futa Shamba",
        "corporateRegistrationNum": "Nambari ya Usajili wa Kampuni",
        "farmLocationIsRequired": "Eneo la Shamba linahitajika."
    },
    "deforestation": {
        "addZoneToThisFarm": "Ongeza Kanda kwenye shamba hili",
        "eudrForestAssessment": "Tathmini ya Msitu wa EUDR",
        "requestEudrForestAssessment": "OMBA TATHMINI YA MSITU WA EDR",
        "pleaseChooseOption": "Tafadhali Chagua Chaguo",
        "requestForestReport": "Omba Ripoti ya Msitu",
        "noDeforestationReportMsg": "Hakuna ripoti za ukataji miti zimeombwa. Tafadhali naomba ripoti za ukataji miti ili ziorodheshwe hapa.",
        "allCountries": "Nchi Zote",
        "allRegions": "Mikoa Yote",
        "allFarms": "Mashamba Yote",
        "allStatus": "Hali Yote",
        "viewCertificate": "Angalia Cheti",
        "requestComplianceCertificate": "OMBA CHETI CHA KUFUATA",
        "assessmentNo": "Tathmini Na",
        "blockchainCertificationInfo": "Hash ya Uthibitishaji wa Cheti cha Blockchain Itapatikana Baada ya Kukubaliwa kwa Cheti",
        "blockchainCertificationValidation": "Uthibitishaji wa Cheti cha Blockchain",
        "openBlockchainPage": "Fungua Ukurasa wa Blockchain",
        "clickOnAboveLink": "Bofya kiungo hapo juu ili kuthibitisha cheti kwenye blockchain",
        "shareCertificate": "Cheti cha Shiriki",
        "high": "Juu",
        "low": "Chini",
        "zeroOrNegigible": "Sufuri au Isiyoeleweka",
        "deforestationProbability": "Uwezekano wa ukataji miti",
        "colorCode": "Msimbo wa Rangi",
        "geofenceAarea": "Eneo la Geofence",
        "percentageOfGeofenceArea": "Asilimia ya Eneo la Geofence",
        "overallDeforestationProbability": "Uwezekano wa Ukataji miti kwa ujumla",
        "deforestationComplianceReport": "Ripoti za Uzingatiaji wa Ukataji miti",
        "noDeforestationComplianceReport": "Hakuna Ripoti ya Upataji wa Ukataji miti iliyopatikana",
        "loadingDeforestationComplianceReport": "Inapakia Ripoti ya Makubaliano ya Ukataji miti",
        "farmRegistrationId": "Kitambulisho cha Usajili wa Shamba",
        "farmerName": "Jina la Mkulima",
        "farmerRegistrationId": "Kitambulisho cha Usajili wa Mkulima",
        "uniqueFarmerId": "Kitambulisho cha Kipekee cha Mkulima",
        "uniqueFarmId": "Kitambulisho cha Kipekee cha Shamba",
        "farmLocation": "Eneo la Shamba",
        "area": "Eneo",
        "farmAddress": "Anwani ya shamba",
        "dateOfRequest": "Tarehe ya Ombi",
        "status": "Hali",
        "settings": "Mipangilio",
        "assignmentIssued": "Kazi Imetolewa",
        "certificateIssued": "Cheti Kimetolewa",
        "complianceCertification": "Uthibitisho wa Kuzingatia",
        "noComplianceCertification": "Hakuna Uthibitishaji wa Utiifu uliopatikana",
        "loadingComplianceCertification": "Inapakia Cheti cha Uzingatiaji",
        "assessmentReport": "Ripoti ya Tathmini",
        "downloadPDF": "Pakua PDF",
        "print": "Chapisha",
        "back": "Nyuma",
        "farmDetails": "Maelezo ya Shamba",
        "dimitraFarmId": "Kitambulisho cha Shamba la Dimitra",
        "dimitraFermerId": "Kitambulisho cha Mkulima cha Dimitra",
        "totalGeofenceAreaHA": "Jumla ya Eneo la Geofence (HA)",
        "forestLossHA": "Upotevu wa Msitu (HA)",
        "forestGainHA": "Faida ya Msitu (HA)",
        "forestUnchangedHA": "Msitu Usiobadilika (HA)",
        "forestUnchanged": "Msitu Usiobadilika",
        "forestLoss": "Kupoteza Msitu",
        "forestGain": "Faida ya Msitu",
        "totalGeofenceArea": "Jumla ya Eneo la Geofence",
        "forestAssessmentHelp": "Ikiwa una maswali kuhusu ripoti hii au unahitaji usaidizi kuielewa, wasiliana nasi kupitia Dawati la Usaidizi.",
        "allReport": "Ripoti Zote",
        "deforestationRepot": "Ripoti za ukataji miti",
        "requestDeforestationReportNow": "OMBA RIPOTI YA UKOSEFU WA MISITU SASA",
        "noRecordFound": "Hakuna Rekodi Imepatikana",
        "noDeforestationReportRequested": "Hakuna ripoti za ukataji miti zimeombwa. Tafadhali naomba ripoti za ukataji miti ili ziorodheshwe hapa.",
        "deforestationImage": "Picha ya Ukataji miti",
        "reqDeforestationReport": "Omba Ripoti ya Ukataji miti",
        "confirm": "Thibitisha",
        "newForestArea": "Eneo Mpya la Msitu",
        "deforestedArea": "Eneo lililokatwa miti",
        "existingForestArea": "Eneo la Msitu lililopo",
        "deforestation": "Ukataji miti",
        "farmName": "Jina la Shamba",
        "location": "Mahali",
        "dateOfInterest": "Tarehe ya Kuvutiwa",
        "geofenceArea": "Eneo la Geofence (HA)",
        "deforestationArea": "Eneo la ukataji miti (HA)",
        "treeGainArea": "Eneo la Kupata Miti (HA)",
        "currentForestArea": "Eneo la Msitu la Sasa (HA)",
        "view": "Tazama",
        "locationInfoRequired": "Maelezo ya Eneo yanahitajika",
        "geofenceNameRequired": "Jina la geofence linahitajika",
        "futureDateSelected": "Tarehe ya baadaye imechaguliwa",
        "reportGeneratedSuccessfully": "Ripoti imetolewa",
        "reportCannotAdded": "Ripoti haiwezi kuongezwa.",
        "primaryFarmNotFound": "Shamba la msingi halijapatikana.",
        "pleaseRegisterFarmFirst": "Tafadhali sajili shamba kwanza"
    },
    "certificate": {
        "allCertificate": "Vyeti vyote",
        "certificate": "Cheti"
    }
}